<template>
  <!--<div id="app">-->
  <!--<img alt="Vue logo" src="./assets/logo.png">-->
  <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
  <!--</div>-->
  <router-view/>

</template>

<script>
	import format from 'string-format'

	import HelloWorld from './components/HelloWorld.vue'
	import {mapActions} from "vuex"

	export default {
		name: 'App',
		ref: 'app',
		components: {
			HelloWorld
		},

		data: function () {
			return {
				lists_promise: null,
			}
		},

		mounted() {
			console.log('App.mounted()')
			this.load_lists()
		},

		methods: {

			// ...mapActions({
			// 	message_add: 'message/add',
			//
			// 	progress_begin: 'progress/begin',
			// 	progress_end: 'progress/end',
			//
			// 	plate_set_filter: 'plate/set_filter',
			// }),

			load_lists: function () {
				return this.lists_promise = this.$store.dispatch('lists/fetch')
					.then(function (result) {
						console.log("App.load_lists() then")
					})
			}
		}
	}
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>
